export class Event {
  eventGuid: string;
  eventName: string;
  creationDate: Date;
}
